export const blockIconsFileCloudQueue = (
	<span className='material-symbols-outlined'>cloud_queue</span>
);
